import { SYNC_SEARCH_TERM } from './searchActionTypes';
export const syncSearchTermAction = (searchTerm, skipSync = false) => ({
  type: SYNC_SEARCH_TERM,
  payload: {
    searchTerm,
    skipSync
  }
});